module.exports = __webpack_public_path__ + "img/ic_publicity_detail8_3.a224c8a3.jpg";